import { authRoute } from './auth';
import { signinRoute } from './signin';
export { profileRoute } from './profile';

export const allAuthRoute = [
  authRoute(),
  signinRoute(),
];
